import { api } from "@/lib/api";

export interface ChecklistItemAttachment {
	id: string;
	checklist_item_id: string;
	file_url: string;
	file_path: string;
	file_name: string;
	mime_type: string;
	file_size: number;
	uploaded_by: string | null;
	created_at: string;
}

function readFileAsDataUrl(file: File): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			if (typeof reader.result === "string") {
				resolve(reader.result);
			} else {
				reject(new Error("Failed to read file."));
			}
		};
		reader.onerror = () => reject(new Error("Failed to read file."));
		reader.readAsDataURL(file);
	});
}

export async function listChecklistItemAttachments(
	projectId: string,
	taskId: string,
	itemId: string,
): Promise<ChecklistItemAttachment[]> {
	const res = await api.get<{
		success: boolean;
		count: number;
		data: ChecklistItemAttachment[];
	}>(
		`/projects/${projectId}/tasks/${taskId}/checklist-items/${itemId}/attachments`,
	);
	return res.data;
}

export async function uploadChecklistItemAttachment(
	projectId: string,
	taskId: string,
	itemId: string,
	file: File,
): Promise<ChecklistItemAttachment> {
	const dataUrl = await readFileAsDataUrl(file);
	const res = await api.post<{
		success: boolean;
		data: ChecklistItemAttachment;
	}>(
		`/projects/${projectId}/tasks/${taskId}/checklist-items/${itemId}/attachments`,
		{
			data: dataUrl,
			content_type: file.type,
			file_name: file.name,
		},
	);
	return res.data;
}

export async function deleteChecklistItemAttachment(
	projectId: string,
	taskId: string,
	itemId: string,
	attachmentId: string,
): Promise<void> {
	await api.delete(
		`/projects/${projectId}/tasks/${taskId}/checklist-items/${itemId}/attachments/${attachmentId}`,
	);
}
